import state from './client.state'
import mutations from './client.mutations'
import actions from './client.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
